import { HostListener, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  isDesktop:boolean = false;

  imgUrl:string= 'assets/img/blackAll.png';
  emailstring:string= "mailto:info@segurnet.com?Subject=Cotizar Poliza de Seguro";
  callUs:string='tel:+1-809-620-2524';

  whatsUs:string='https://api.whatsapp.com/send?phone=18096202524&text=Hola!, necesito tu ayuda para solicitar una Póliza de Seguros.';
  cordenate:string='https://goo.gl/maps/Roi7AEStWadCJ5eX8';

  url:string = 'cotiza?p=';

  mensaje:string='https://api.whatsapp.com/send?phone=18096202524&text=Saludos, les escribo para solicitar asistencia en cuanto las pólizas de seguros';

  //datos para los botones de cotizar
  urlAsset:string="assets/img/"
  services:any =[
    {
      srcLightImg: this.urlAsset+"car.png",
      formUrl: "vehiculo",
      description: "Seguros de Vehículos",
      srcIcon: "segcar",
      active: true
    },
    {
      srcLightImg: this.urlAsset+"family.png",
      formUrl: "salud",
      description: "Seguros de Salud",
      srcIcon: "segSalud",
      active: true
    },
    {
      srcLightImg: this.urlAsset+"plane.png",
      formUrl: "viajes",
      description: "Seguros de Viajes",
      srcIcon: "segViaj",
      active: true
    },
    {
      srcLightImg: this.urlAsset+"family.png",
      formUrl: "vida",
      description: "Seguros de Vida",
      srcIcon: "segVida",
      active: true
    },
    {
      srcLightImg: this.urlAsset+"home.png",
      formUrl: "propiedad",
      description: "Seguros de Propiedades",
      srcIcon: "segHogar",
      active: true
    },
    {
      srcLightImg: this.urlAsset+"masivos.png",
      formUrl: "masivos",
      description: "Seguros Masivos",
      srcIcon: "segMasi",
      active: false
    },
    {
      srcLightImg: this.urlAsset+"corporativo.png",
      formUrl: "corporativos",
      description: "Seguros Corporativos",
      srcIcon: "segCorp",
      active: false
    }
  ]

  constructor(private router: Router) { }

  ngOnInit(): void {
    if(window.innerWidth>799){
      this.isDesktop=true;
    }
  }

  //Saber si movio la el tamaño de la ventana
 @HostListener('window:resize', ['$event'])
  listengResize(event:any){
    if(event.target.innerWidth>799){
      this.isDesktop=true;
    }else{
      this.isDesktop=false;
    }
  }

  //ir al formulario
  goToform(val:string){
    this.router.navigate(['/cotiza', { p: val } ])
  }

  //Cambiar la imagen
 changeSrc(url:string){
  this.imgUrl = url;
 }
 //poner la que estaba antes
  backSrc(){
    this.imgUrl = 'assets/img/blackAll.png';
 }

 //abrir wassap
 goWhatapp(){
  window.open(this.whatsUs, "_blank");
 }

 //abrir map
 verMap(){
  window.open(this.cordenate, "_blank");
 }

// alert for masive and corpo
getAlert(text:string){
  console.log(text)
  Swal.fire({
    title: 'Contáctanos',
    html: 'Para seguros '+text+' comunícate con nosotros al 809-620-2524, también puedes<br><a href="tel:8096202524" target="_blank" style="color: #FF6720">llamarnos ahora</a> o <a href="'+this.mensaje+' de '+text+'." target="_blank" style="color: #FF6720">escríbirnos a WhatsApp</a>',
    confirmButtonColor: '#FF6720',
    confirmButtonText: 'Ir atrás'
  })
}




}
